import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertText(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "span",
    properties: _objectSpread({}, props)
  };
}
//# sourceMappingURL=convertText.js.map